import React from 'react';
import { FileText, Award, MessageSquare } from 'lucide-react';

const mockEvaluatedAssignment = {
  id: 1,
  title: 'Math Problem Set',
  subject: 'Mathematics',
  questions: [
    { 
      id: 1, 
      question: 'Solve the quadratic equation: x^2 + 5x + 6 = 0', 
      pdfUrl: '#', 
      marks: 8, 
      totalMarks: 10,
      remarks: 'Good work on factoring. Remember to check your solutions.'
    },
    { 
      id: 2, 
      question: 'Find the derivative of f(x) = 3x^2 - 2x + 1', 
      pdfUrl: '#', 
      marks: 9, 
      totalMarks: 10,
      remarks: 'Excellent application of the power rule and constant rule.'
    },
    { 
      id: 3, 
      question: 'Calculate the area under the curve y = x^2 from x = 0 to x = 2', 
      pdfUrl: '#', 
      marks: 7, 
      totalMarks: 10,
      remarks: 'Correct approach, but be careful with your integration limits.'
    },
  ],
  totalMarks: 24,
  totalPossibleMarks: 30,
  overallRemarks: 'Good effort overall. Focus on double-checking your work and paying attention to details.'
};

export default function EvaluatedAssignment() {
  // const { id } = useParams();
  const assignment = mockEvaluatedAssignment; // In a real app, fetch the assignment based on the id

  return (
    <div className="bg-gradient-to-br from-blue-100 to-purple-100 ">
    <div className="max-w-4xl mx-auto px-4 py-8 bg-gray-50 min-h-screen bg-gradient-to-br from-blue-100 to-purple-100">
      <h1 className="text-4xl font-bold text-gray-900 mb-6">{assignment.title}</h1>
      <div className="bg-blue-100 text-blue-800 px-4 py-2 rounded-full inline-block mb-6 font-semibold">
        {assignment.subject}
      </div>
      <div className="mb-8 bg-white shadow-lg rounded-lg p-6">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center">
          <Award className="w-6 h-6 mr-2 text-yellow-500" />
          Your Results
        </h2>
        <div className="text-lg mb-4">
          Total Score: <span className="font-bold text-2xl text-blue-600">{assignment.totalMarks}</span> / {assignment.totalPossibleMarks}
        </div>
        <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded">
          <h3 className="text-lg font-semibold text-yellow-800 mb-2 flex items-center">
            <MessageSquare className="w-5 h-5 mr-2" />
            Overall Remarks
          </h3>
          <p className="text-yellow-700">{assignment.overallRemarks}</p>
        </div>
      </div>
      <div className="space-y-6">
        {assignment.questions.map((question, index) => (
          <div key={question.id} className="bg-white shadow-lg rounded-lg p-6 transition duration-300 ease-in-out hover:shadow-xl">
            <h3 className="text-xl font-semibold text-gray-800 mb-2">Question {index + 1}</h3>
            <p className="text-gray-600 mb-4">{question.question}</p>
            <div className="flex items-center justify-between mb-4">
              <a
                href={question.pdfUrl}
                className="flex items-center text-blue-500 hover:text-blue-600 transition duration-300 ease-in-out bg-blue-50 px-4 py-2 rounded-full"
              >
                <FileText className="w-5 h-5 mr-2" />
                <span className="text-sm font-medium">View Your Answer</span>
              </a>
              <div className="text-lg">
                Score: <span className="font-bold text-green-600">{question.marks}</span> / {question.totalMarks}
              </div>
            </div>
            <div className="bg-green-50 border-l-4 border-green-400 p-4 rounded">
              <h4 className="text-lg font-semibold text-green-800 mb-2 flex items-center">
                <MessageSquare className="w-5 h-5 mr-2" />
                Teacher's Remarks
              </h4>
              <p className="text-green-700">{question.remarks}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
    </div>
  );
}